import api from './api';

const vaultfoliourlService = {
    getUrl: async (vaultid, reservationId, s3key, disposition = 'inline') => {
        const response = await api.post('/vaultfoliourl', { vaultid, reservationId, s3key, disposition });
        return response.data;
    },

    // THE SHARED CALL: the folio document for one result row, whatever PMS the vault came from.
    //
    // getUrl above makes the CALLER decide how the document is addressed — an s3_key for OHIP, a
    // reservation id for OperaV5 — which means every screen has to know how each PMS stores its folios,
    // and a third PMS would mean a third branch in the UI. This sends the row as it came back from the
    // search and lets the backend resolve it (DOCUMENT_RESOLVERS in the vaultfoliourl lambda, one entry
    // per source type).
    //
    // getUrl stays for the callers that legitimately hold a bare key — the file browser and the eREG
    // card viewer, which address objects that are not folios.
    getDocumentUrlForRow: async (vaultid, row, disposition = 'inline') => {
        const response = await api.post('/vaultfoliourl', { vaultid, row, disposition });
        return response.data;
    }
};

export default vaultfoliourlService;
